import * as ActionPartnerTypes from 'actions/partner';

const defaultState = {};

export default function account(state = defaultState, action) {
  switch (action.type) {
    case ActionPartnerTypes.ACCOUNT_UPDATE_RECEIVE:
    case ActionPartnerTypes.ACCOUNT_RECEIVE:
      return action.payload;
    default:
      return state;
  }
}
